import Vue from 'vue';
import Router from 'vue-router';
import {
  commonRouter,
  // personalRouter,
  // exRouter,
  // coRouter,
  otcRouter,
} from './modules/index';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    ...commonRouter,
    // 个人中心
    // ...personalRouter,
    // ...exRouter,
    // ...coRouter,
    ...otcRouter,
    // {
    //   path: '*',
    //   component: () => import('@/views/home/index.vue'),
    //   redirect: '/',
    // },
  ],
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition) {
      return savedPosition;
    }
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  },
});

export default router;
